import useGlobalContext from "hooks/globalData";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResponseCode } from "services/KnowfullyAdminClient";
import ConfirmDialog from "components/ConfirmDialog";

type CloneEmailTemplateDialogProps = {
  emailTemplateId?: string;
  close: () => void;
};

export default function CloneEmailTemplateDialog({
  emailTemplateId,
  close,
}: CloneEmailTemplateDialogProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { emailTemplateDetailsUrl, emailService } = useGlobalContext();

  const cloneEmailTemplate = async () => {
    if (!emailTemplateId) {
      return;
    }

    const cloneResponse = await emailService.cloneEmailTemplate(
      emailTemplateId
    );
    if (cloneResponse.responseCode === ResponseCode.OK) {
      queryClient.invalidateQueries("emailTemplates");
      navigate(emailTemplateDetailsUrl(cloneResponse.data?.id));
      close();
    }
  };

  return (
    <ConfirmDialog
      dialogTitleKey="cloneEmailTemplate"
      contentKey="cloneEmailTemplateConfirmationMessage"
      confirmLabel="okButton"
      open={!!emailTemplateId}
      onCancel={close}
      handleConfirm={cloneEmailTemplate}
    />
  );
}
